/**
 * Shared utility for formatting agent data into SearchSelect options
 */

/**
 * Convert an array of agent objects into SearchSelect options with proper icon metadata
 * @param {Array} agents - Array of agent objects from the API
 * @param {Object} options - Configuration options
 * @param {boolean} options.useIdPrefix - Whether to prefix value with 'id:' (default: false)
 * @returns {Array} Array of SearchSelect option objects
 */
export function formatAgentOptions(agents: any[], { useIdPrefix = false }: { useIdPrefix?: boolean } = {}): Array<any> {
  if (!Array.isArray(agents)) return []
  
  return agents
    .map((a) => {
      const id = a?.id
      const name = String(a?.name || '').trim()
      
      if (!id || !name) return null
      
      const value = useIdPrefix ? `id:${id}` : String(id)
      
      return {
        value,
        label: name,
        iconKey: a?.icon_name ? null : 'agent',
        iconName: a?.icon_name || null,
        iconStyle: a?.icon_style || 'outline',
        iconColor: a?.icon_color || '#6b7280',
      }
    })
    .filter(Boolean)
}
